<template>
  <closable-list-item
    :is-visible="isForwardingEnabled && !isHiddenForwardingEnabledNotification"
    path-name="incomingCallHandling"
    @close="hideForwardingEnabledNotification"
  >
    <template #content>
      <div class="shrink-0 bg-threshold-tints-600 rounded-full h-12 w-12 flex items-center justify-center text-black">
        <wui-icon
          name="missedCall"
          large
          class="-scale-x-100"
        />
      </div>
      <span class="text-1316 text-wrap max-w-[264px]">
        {{ $t('common.forwardEnabledDescription') }}
      </span>
    </template>
  </closable-list-item>
</template>

<script lang="ts" setup>
import { WuiIcon } from '@wui/common-library'
import { storeToRefs } from 'pinia'

import { useStoreSettingsForwarding, isHiddenForwardingEnabledNotification, hideForwardingEnabledNotification } from '@/entities/forwarding'

import { ClosableListItem } from '@/shared/components/closable-list-item'

const { isForwardingEnabled } = storeToRefs(useStoreSettingsForwarding())
</script>
